import CRUDActions from '../CRUD';
import Product from '../../api/product';

class ProductCrud extends CRUDActions {
  prefix = 'shop_product';

  get _model() {
    return Product;
  }

}

export default new ProductCrud();




// WEBPACK FOOTER //
// ./src/actions/shop/products.js